export default [{
    path: '/admin/user/list',
    name: 'list',
    component: () => import('@/views/user/list'),
    meta: {
      title: '会员管理'
    }
  },
  {
    path: '/admin/user/details_user',
    name: 'details_user',
    component: () => import('@/views/user/details_user'),
    meta: {
      title: '会员详情'
    }
  },
  {
    path: '/admin/user/details_money',
    name: 'details_money',
    component: () => import('@/views/user/details_money'),
    meta: {
      title: '金额详情'
    }
  },
  {
    path: '/admin/user/details_integral',
    name: 'details_integral',
    component: () => import('@/views/user/details_integral'),
    meta: {
      title: '积分详情'
    }
  },
  {
    path: '/admin/user/sign_record',
    name: 'sign_record',
    component: () => import('@/views/user/sign_record'),
    meta: {
      title: '签到记录'
    }
  },
  {
    path: '/admin/user/carry_money',
    name: 'carry_money',
    component: () => import('@/views/user/carry_money'),
    meta: {
      title: '提现记录'
    }
  },
  {
    path: '/admin/user/level_user',
    name: 'level_user',
    component: () => import('@/views/user/level_user'),
    meta: {
      title: '会员等级'
    }
  },
  {
    path: '/admin/user/recharge',
    name: 'recharge',
    component: () => import('@/views/user/recharge'),
    meta: {
      title: '充值订单'
    }
  },
  {
    path: '/admin/user/message',
    name: 'UserMessage',
    component: () => import('@/views/user/message'),
    meta: {
      title: '消息推送'
    }
  },
  {
    path: '/admin/user/info',
    name: 'UserInfo',
    component: () => import('@/views/user/user_info'),
    meta: {
      title: '会员档案'
    }
  },
  {
    path: '/admin/user/distributor_money_log',
    name: 'distributorMoneyLog',
    component: () => import('@/views/user/distributor_money_log'),
    meta: {
      title: '分销资金明细'
    }
  },
  {
    path: '/admin/user/offline_recharge',
    name: 'OfflineRecharge',
    component: () => import('@/views/user/offline_recharge'),
    meta: {
      title: '线下充值'
    }
  },
  {
    path: '/admin/user/service/list',
    name: 'UserServiceList',
    component: () => import('@/views/user/service/list'),
    meta: {
      title: '服务列表'
    }
  },
  {
    path: '/admin/user/service/dtl',
    name: 'UserServiceDtl',
    component: () => import('@/views/user/service/dtl'),
    meta: {
      title: '服务详情'
    }
  },
  {
    path: '/admin/user/service/policeList',
    name: "policeList",
    component: () => import('@/views/user/service/policeList'),
    meta: {
      title: '接警联系人'
    }
  },
  {
    path: '/admin/user/service/callConfig',
    name: "callConfig",
    component: () => import('@/views/user/service/callConfig'),
    meta: {
      title: '接警设置'
    }
  },
  {
    path: '/admin/user/record/list',
    name: "recordDetails",
    component: () => import('@/views/user/record/list'),
    meta: {
      title: '档案列表'
    }
  },
  {
    path: '/admin/user/record/details',
    name: "recordDetails",
    component: () => import('@/views/user/record/details'),
    meta: {
      title: '档案信息'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/user.js